import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';


export default function MlmcreditListTableHeader(){
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        {/* <Grid item lg={2} xs={1} ><Typography variant="h5"> Title </Typography></Grid> */}
                        <Grid item lg={2} xs={2} ><Typography variant="h5"> # </Typography></Grid>
                        <Grid item lg={4} xs={3} ><Typography variant="h5"> Via </Typography></Grid>
                        <Grid item lg={2} xs={2} ><Typography variant="h5"> Level </Typography></Grid>
                        {/* <Grid item lg={2} xs={1} ><Typography variant="h5"> Sr Partner Id </Typography></Grid> */}
                        <Grid item lg={4} xs={5} ><Typography variant="h5"> Your Credit </Typography></Grid>
                        

      </Grid>
      
    )
}